// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HDYZ","clinicsSelect":"styles_clinicsSelect__8g-zF"};